export default __webpack_public_path__ + "static/media/admin.8a81c826.svg";